<template>
  <div class="impressum">
    <main class="impressum-container">
      <gradient-title class="title" text="Impressum" />

      <div class="content">
        <h2>Angaben gemäß § 5 TMG</h2>
        <p>
          CodePod Ariel Podzorski<br>
          Hubert-Korte-Str. 40<br>
          49086 Osnabrück
        </p>

        <h2>Kontakt</h2>
        <p>Für Anfragen nutzen Sie bitte das Kontaktformular auf dieser Website.</p>

        <h2>Umsatzsteuer-ID</h2>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br>
          DE421912646
        </p>

        <h2>Haftung für Inhalte</h2>
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
        </p>

        <h2>Haftung für Links</h2>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
        </p>
        <p>
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </p>

        <h2>Urheberrecht</h2>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        </p>
        <p>
          Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        </p>
      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import GradientTitle from "@/components/GradientTitle.vue";
</script>

<style scoped>
.impressum {
  flex: 1;
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.impressum-container {
  width: 100%;
}

.title {
  text-align: center;
  margin-bottom: 3rem;
}

.content {
  line-height: 1.7;
  color: #333;
  font-size: 1rem;
}

.content h2 {
  color: #1a1a2e;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 3rem 0 1.5rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #00d1b2;
}

.content h3 {
  color: #1a1a2e;
  font-size: 1.2rem;
  font-weight: 600;
  margin: 2rem 0 1rem 0;
}

.content h4 {
  color: #333;
  font-size: 1.1rem;
  font-weight: 600;
  margin: 1.5rem 0 0.8rem 0;
}

.content p {
  margin-bottom: 1rem;
}

.content a {
  color: #00d1b2;
  text-decoration: none;
  transition: color 0.2s ease;
  word-break: break-all;
}

.content a:hover {
  color: #00b8a3;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .impressum {
    padding: 1rem;
  }

  .content {
    font-size: 0.95rem;
  }

  .content h2 {
    font-size: 1.3rem;
  }

  .content h3 {
    font-size: 1.1rem;
  }

  .content h4 {
    font-size: 1rem;
  }
}
</style>
